<template>
    <div class="mit-admin-storage-page mit-page">
        <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card">
              <v-card-title>API Access</v-card-title>
              <v-card-subtitle class="caption">CSAIL api and keys</v-card-subtitle>
              <v-divider></v-divider>
                <MitApiKey></MitApiKey>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
  import MitApiKey from '../components/MitApiKey.vue';

  export default {
    name: 'MitAdminApiPage',
    components: {
      MitApiKey
    },
    data: function() {
      return {
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {

    },
    methods: {
      test(){

      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .mit-table {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .mit-my-borrowed-list {
    padding-bottom: 30px;
  }
</style>
